module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.login, {
    tag: "component",
    attrs: {
      "type": _vm.type
    },
    on: {
      "showregist": _vm.showIt
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b717934a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 643
// module chunks = 31